<template>
  <v-divider class="mb-7" />
  <FormHeading :h="3">{{ $tt('visit_details') }}</FormHeading>
  <FormBlock>
    <AppRow>
      <EntryDatePicker v-model="entry.date" :hint="dateHint" />
      <PortSelect v-if="hasPort" v-model="entry.port" type="entry" />
      <AerialEntryAlert v-if="aerial" />
    </AppRow>
  </FormBlock>
  <FormBlock v-if="entry.crossing">
    <BorderCrossingFields v-model="entry.crossing" />
  </FormBlock>
</template>

<script setup lang="ts">
import type { Entry } from '~/types';

const entry = defineModel<Entry>({ required: true });
defineProps<{
  hasPort?: boolean;
  aerial?: boolean;
  dateHint?: string;
  hasCrossing?: boolean;
}>();
</script>